import styled from 'styled-components'

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 1170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 0 16px;
  .title {
    width: 100%;
    line-height: 120%;
    font-size: 64px;
    text-align: center;
  }

  .content {
    margin-top: 88px;
    color: ${({ theme }) => theme.colors.darkgray};
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 32px;

    .image {
      display: flex;
      height: 100%;
      max-width: 500px;

      img {
        position: relative !important;
      }
    }

    ul,
    ol {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 32px;
      padding: 0 10px;
      li {
        font-size: 16px;
        line-height: 120%;
        font-weight: 500;
      }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 120%;
      font-weight: bold;
    }
    h1 {
      font-size: 64px;
    }
    h2 {
      font-size: 48px;
    }
    h3 {
      font-size: 32px;
      margin-top: 48px;
    }
    h4 {
      font-size: 24px;
    }
    h5,
    h6,
    p {
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      width: 100%;
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
      align-self: flex-start;
    }

    pre {
      background-color: ${({ theme }) => theme.colors.darkgray};
      padding: 10px;
      border-radius: 10px;
      code {
        white-space: pre-wrap;
        color: ${({ theme }) => theme.colors.lightgray};
        font-size: 16px;
        line-height: 150%;
      }
    }

    blockquote {
      display: flex;
      position: relative;
      height: 100%;

      &::after {
        content: '';
        position: absolute;
        height: 100%;
        width: 5px;
        background-color: ${({ theme }) => theme.colors.lightgray};
        opacity: 0.2;
        left: 0;
      }
      p {
        padding: 10px 0 10px 20px;
        font-style: italic;
        font-weight: 300;
      }
    }
    p > img {
      max-width: 500px;
      margin-top: 80px;
    }

    a {
      color: ${({ theme }) => theme.colors.primary_4};
      transition: filter 0.2s;
      &:hover {
        filter: brightness(0.8);
      }
    }

    @media (max-width: 791px) {
      margin-top: 12px;
      gap: 24px;
      h2,
      h3,
      h4,
      p {
        line-height: 150%;
      }
      h1 {
        font-size: 28px;
      }
      h2 {
        font-size: 24px;
      }
      h3 {
        font-size: 20px;
        margin-top: 16px;
      }
      h4 {
        font-size: 16px;
      }
      p {
        font-size: 12px;
        font-weight: 500px;
      }
    }
  }

  @media (max-width: 791px) {
    .title {
      font-size: 28px;
    }

    gap: 16px;
  }
`

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`
